export function downloadImageWithReferral(url, referralCode, name) {
  try {
    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        // --- Text + Bubble Layout (Top-right corner) ---
        const fontSize = 72;
        ctx.font = `bold ${fontSize}px Arial`;
        ctx.textBaseline = "middle";

        const paddingTop = 40;
        const paddingRight = 40;
        const textWidth = ctx.measureText(referralCode).width;
        const bubbleWidth = textWidth + 60;
        const bubbleHeight = fontSize + 40;

        const bubbleX = canvas.width - bubbleWidth - paddingRight;
        const bubbleY = paddingTop;

        // --- Darker Frosted Glass Bubble ---
        ctx.save();
        ctx.shadowColor = "rgba(0, 0, 0, 0.5)";
        ctx.shadowBlur = 12;
        ctx.shadowOffsetX = 4;
        ctx.shadowOffsetY = 4;
        ctx.fillStyle = "rgba(0, 0, 0, 0.55)"; // Darker frosted effect
        drawRoundedRect(ctx, bubbleX, bubbleY, bubbleWidth, bubbleHeight, 20);
        ctx.fill();
        ctx.restore();

        // --- Text Overlay ---
        ctx.fillStyle = "white";
        ctx.textAlign = "right";
        ctx.fillText(referralCode, canvas.width - paddingRight - 30, bubbleY + bubbleHeight / 2);

        // --- Convert canvas to Blob and trigger download ---
        // canvas.toBlob((blob) => {
        //   if (!blob) {
        //     alert("Error: Failed to generate image.");
        //     return;
        //   }

        //   try {
        //     const url = URL.createObjectURL(blob);

        //     // ✅ Post message to Flutter WebView
        //     if (window.RoyalSkyWebViewDownloads && window.RoyalSkyWebViewDownloads.postMessage) {
        //       window.RoyalSkyWebViewDownloads.postMessage("DOWNLOAD_URL:"+url);
        //     } else {
        //       console.log("DOWNLOAD_URL:"+url);
        //     }

        //     // 🔽 Trigger Download
        //     const link = document.createElement("a");
        //     link.href = url;
        //     link.download = name + ".png";
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //     URL.revokeObjectURL(url);
        //   } catch (downloadErr) {
        //     console.error("Download error:", downloadErr);
        //     alert("Download failed. Try a different browser or long-press to save.");
        //   }
        // }, "image/png");

        // --- Convert canvas to Base64 and send to Flutter WebView ---
        const base64 = canvas.toDataURL("image/png");

        try {
          if (window.RoyalSkyWebViewDownloads?.postMessage) {
            // window.RoyalSkyWebViewDownloads.postMessage(
            //   {
            //     type: "image",
            //     name: name,
            //     url: base64
            //   }
            // );
            window.RoyalSkyWebViewDownloads.postMessage(base64);
          } else {
            console.log({
                type: "image",
                name: name,
                url: base64
              });
          }
        } catch (err) {
          console.error("Failed to post base64 to WebView", err);
          alert("Failed to send image data. Try again.");
        }

      } catch (drawErr) {
        console.error("Drawing error:", drawErr);
        alert("Something went wrong while drawing the poster.");
      }
    };

    img.onerror = () => {
      alert("Image failed to load. Please check the URL.");
    };

    img.src = url + "?t=" + Date.now();
  } catch (err) {
    console.error("Unexpected error:", err);
    alert("Unexpected error occurred. Please try again.");
  }
}

// Helper function to draw rounded rectangle
function drawRoundedRect(ctx, x, y, width, height, radius) {
  if (width < 2 * radius) radius = width / 2;
  if (height < 2 * radius) radius = height / 2;
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + width, y, x + width, y + height, radius);
  ctx.arcTo(x + width, y + height, x, y + height, radius);
  ctx.arcTo(x, y + height, x, y, radius);
  ctx.arcTo(x, y, x + width, y, radius);
  ctx.closePath();
}